import { render } from "./CategoryWasteList.vue?vue&type=template&id=1bf65ad1&scoped=true"
import script from "./CategoryWasteList.vue?vue&type=script&lang=js"
export * from "./CategoryWasteList.vue?vue&type=script&lang=js"

import "./CategoryWasteList.vue?vue&type=style&index=0&id=1bf65ad1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf65ad1"]])

export default __exports__